import React from "react";

import { Button } from "carbon-components-react";
import { DocumentDownload16 } from "@carbon/icons-react";
import {
  AppShape,
  LoanApplicationBorrower,
  HurdleShape,
  DocTypes,
  CreditReport,
  LoanApplicationBorrowers,
} from "@eave/shared/types/api";
import { getAssociatedBorrowers, getBorrowerEntitiesAsStrings } from "@eave/shared/utils/borrowers";
import { getFileDownloadBaseURL } from "config";
import { logException } from "web_modules/utils/sentry";
import HurdleView from "underwriter_dashboard/shared/HurdleView";
import APIClient from "../../APIClient";

import DocumentUploader from "../../DocumentUploader";
import WorksheetEditor from "../shared/WorksheetEditor";

interface HurdleEditorProps {
  app: AppShape;
  hurdle: HurdleShape;
  onHide: Function;
}

const ERROR_DOWNLOAD_DU_MESSAGE =
  "There was an error downloading the DU data file. Please try again or notify support channel.";

export const DesktopUnderwriterHurdleEditor: React.FC<HurdleEditorProps> = props => {
  const { app, hurdle, onHide } = props;

  const downloadMISMO = () => {
    APIClient.post(`/uw/${app.id}/mismo_34`, {})
      .then((response: any) => {
        const { filename, s3_key } = response;
        window.location.href = getFileDownloadBaseURL(s3_key, filename);
      })
      .catch(err => {
        logException(err);
        alert(ERROR_DOWNLOAD_DU_MESSAGE);
      });
  };

  return (
    <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
      <div className="row">
        <div className="col-lg-5">
          <p style={{ marginBottom: "10px" }}>Generate MISMO 3.4</p>
          <Button renderIcon={DocumentDownload16} onClick={downloadMISMO}>
            Download MISMO 3.4 File
          </Button>
          <hr />
          <div>
            <p>
              Credit Report Identifier:{" "}
              {(app.credit_reports &&
                renderCreditReportIdForBorrowers(app.credit_reports, app.borrowers)) ||
                "none"}
            </p>
          </div>
        </div>

        <div className="col-lg-7">
          <p>Upload DU Findings</p>
          <DocumentUploader
            documentType={DocTypes.DesktopUnderwriterFindings}
            prompt="Drag and drop or click here to upload the findings from DU."
            applicationID={app.id}
          />
          <p>Results to display on 1008</p>
          <WorksheetEditor
            appId={app.id}
            loanFileWsId={app.loan_file_worksheet_id}
            openToWsName="fannie_mae_status"
          />
        </div>
      </div>
    </HurdleView>
  );
};

function renderCreditReportIdForBorrowers(
  creditReports: CreditReport[],
  borrowers: LoanApplicationBorrowers,
): string {
  let identifierString = "";
  creditReports.forEach(cr => {
    const associatedBorrowers = getAssociatedBorrowers(cr.borrower_entity, borrowers);
    const borrowerEntities = getBorrowerEntitiesAsStrings(associatedBorrowers);
    identifierString += borrowerEntities.join(", ");
    identifierString += `: ${cr.credit_report_identifier}\n`;
  });
  return identifierString;
}

export default DesktopUnderwriterHurdleEditor;
